// Notes:
// - Missing some countries. Example: Greenland
// - Country names may not be politically correct. Example: Gambia vs The Gambia

// Capital Data Notes:
// - Source: https://hub.arcgis.com/datasets/6996f03a1b364dbab4008d99380370ed_0/explore
// - Download: https://opendata.arcgis.com/api/v3/datasets/6996f03a1b364dbab4008d99380370ed_0/downloads/data?format=geojson&spatialRefId=4326&where=1%3D1
// - Manually added missing data for Maldives, Taiwan, Vatican City from Wikipedia
// - Coordinates are `[lon, lat]`

export const COUNTRIES = [
  {
    name: 'Afghanistan',
    continent: 'Asia',
    isoA2: 'AF',
    capital: 'Kabul',
    capitalCoordinates: [69.1367582917535, 34.5309119295288],
  },
  {
    name: 'Albania',
    continent: 'Europe',
    isoA2: 'AL',
    capital: 'Tirana',
    capitalCoordinates: [19.8320043635799, 41.3319959211756],
  },
  {
    name: 'Algeria',
    continent: 'Africa',
    isoA2: 'DZ',
    capital: 'Algiers',
    capitalCoordinates: [3.05000134715283, 36.7832969396894],
  },
  {
    name: 'Andorra',
    continent: 'Europe',
    isoA2: 'AD',
    capital: 'Andorra La Valla',
    capitalCoordinates: [1.51666236264901, 42.4999979554574],
  },
  {
    name: 'Angola',
    continent: 'Africa',
    isoA2: 'AO',
    capital: 'Luanda',
    capitalCoordinates: [13.2350044183293, -8.81199895131659],
  },
  {
    name: 'Antigua and Barbuda',
    continent: 'North America',
    isoA2: 'AG',
    capital: 'Saint John’s',
    capitalCoordinates: [-61.8421765565547, 17.1247770329967],
  },
  {
    name: 'Argentina',
    continent: 'South America',
    isoA2: 'AR',
    capital: 'Buenos Aires',
    capitalCoordinates: [-58.4498336968446, -34.622496010243],
  },
  {
    name: 'Armenia',
    continent: 'Asia',
    isoA2: 'AM',
    capital: 'Yerevan',
    capitalCoordinates: [44.5326753340482, 40.2080310743715],
  },
  {
    name: 'Australia',
    continent: 'Oceania',
    isoA2: 'AU',
    capital: 'Canberra',
    capitalCoordinates: [149.042007430369, -35.3500020570017],
  },
  {
    name: 'Austria',
    continent: 'Europe',
    isoA2: 'AT',
    capital: 'Vienna',
    capitalCoordinates: [16.3209784439172, 48.2021190334445],
  },
  {
    name: 'Azerbaijan',
    continent: 'Asia',
    isoA2: 'AZ',
    capital: 'Baku',
    capitalCoordinates: [49.8159993038217, 40.3239960652242],
  },
  {
    name: 'Bahamas',
    continent: 'North America',
    isoA2: 'BS',
    capital: 'Nassau',
    capitalCoordinates: [-77.3399965916722, 25.0669979452637],
  },
  {
    name: 'Bahrain',
    continent: 'Asia',
    isoA2: 'BH',
    capital: 'Manama',
    capitalCoordinates: [50.5833394186021, 26.2166670378611],
  },
  {
    name: 'Bangladesh',
    continent: 'Asia',
    isoA2: 'BD',
    capital: 'Dhaka',
    capitalCoordinates: [90.4071423233602, 23.7099149440825],
  },
  {
    name: 'Barbados',
    continent: 'North America',
    isoA2: 'BB',
    capital: 'Bridgetown',
    capitalCoordinates: [-59.6158466175446, 13.0958729810337],
  },
  {
    name: 'Belarus',
    continent: 'Europe',
    isoA2: 'BY',
    capital: 'Minsk',
    capitalCoordinates: [27.5755593299317, 53.8999380327474],
  },
  {
    name: 'Belgium',
    continent: 'Europe',
    isoA2: 'BE',
    capital: 'Brussels',
    capitalCoordinates: [4.36799743903299, 50.8370039660422],
  },
  {
    name: 'Belize',
    continent: 'North America',
    isoA2: 'BZ',
    capital: 'Belmopan',
    capitalCoordinates: [-88.800002603656, 17.1199980304069],
  },
  {
    name: 'Benin',
    continent: 'Africa',
    isoA2: 'BJ',
    capital: 'Porto Novo',
    capitalCoordinates: [2.63250030695701, 6.60110404132002],
  },
  {
    name: 'Bhutan',
    continent: 'Asia',
    isoA2: 'BT',
    capital: 'Thimphu',
    capitalCoordinates: [89.6670004408473, 27.4429979248677],
  },
  {
    name: 'Bolivia',
    continent: 'South America',
    isoA2: 'BO',
    capital: 'La Paz',
    capitalCoordinates: [-68.1462446098306, -16.4990069929844],
  },
  {
    name: 'Bosnia and Herzegovina',
    continent: 'Europe',
    isoA2: 'BA',
    capital: 'Sarajevo',
    capitalCoordinates: [18.4300023125018, 43.8699959633257],
  },
  {
    name: 'Botswana',
    continent: 'Africa',
    isoA2: 'BW',
    capital: 'Gaborone',
    capitalCoordinates: [25.9507984015331, -24.6399299266043],
  },
  {
    name: 'Brazil',
    continent: 'South America',
    isoA2: 'BR',
    capital: 'Brasilia',
    capitalCoordinates: [-47.8977476573594, -15.7921109430588],
  },
  {
    name: 'Brunei',
    continent: 'Asia',
    isoA2: 'BN',
    capital: 'Bandar Seri Begawan',
    capitalCoordinates: [114.966999442216, 4.93299897100764],
  },
  {
    name: 'Bulgaria',
    continent: 'Europe',
    isoA2: 'BG',
    capital: 'Sofia',
    capitalCoordinates: [23.3318703962433, 42.7072680587415],
  },
  {
    name: 'Burkina Faso',
    continent: 'Africa',
    isoA2: 'BF',
    capital: 'Ouagadougou',
    capitalCoordinates: [-1.67000367044631, 12.4800030380904],
  },
  {
    name: 'Burundi',
    continent: 'Africa',
    isoA2: 'BI',
    capital: 'Bujumbura',
    capitalCoordinates: [29.3560023202574, -3.37200299636732],
  },
  {
    name: 'Cabo Verde',
    continent: 'Africa',
    isoA2: 'CV',
    capital: 'Praia',
    capitalCoordinates: [-23.520995559507, 14.922999077062],
  },
  {
    name: 'Cambodia',
    continent: 'Asia',
    isoA2: 'KH',
    capital: 'Phnom Penh',
    capitalCoordinates: [104.913189333682, 11.5647390662867],
  },
  {
    name: 'Cameroon',
    continent: 'Africa',
    isoA2: 'CM',
    capital: 'Yaounde',
    capitalCoordinates: [11.5139973664074, 3.86499606415293],
  },
  {
    name: 'Canada',
    continent: 'North America',
    isoA2: 'CA',
    capital: 'Ottawa',
    capitalCoordinates: [-75.6510026845613, 45.3740039621644],
  },
  {
    name: 'Central African Republic',
    continent: 'Africa',
    isoA2: 'CF',
    capital: 'Bangui',
    capitalCoordinates: [18.5623473723784, 4.36585502953802],
  },
  {
    name: 'Chad',
    continent: 'Africa',
    isoA2: 'TD',
    capital: 'Ndjamena',
    capitalCoordinates: [15.2408253958474, 12.1041360316756],
  },
  {
    name: 'Chile',
    continent: 'South America',
    isoA2: 'CL',
    capital: 'Santiago',
    capitalCoordinates: [-70.647515553854, -33.4750230512851],
  },
  {
    name: 'China',
    continent: 'Asia',
    isoA2: 'CN',
    capital: 'Beijing',
    capitalCoordinates: [116.388036416661, 39.9061890457427],
  },
  {
    name: 'Colombia',
    continent: 'South America',
    isoA2: 'CO',
    capital: 'Bogota',
    capitalCoordinates: [-74.080511625698, 4.63022096680315],
  },
  {
    name: 'Comoros',
    continent: 'Africa',
    isoA2: 'KM',
    capital: 'Moroni',
    capitalCoordinates: [43.2430024323497, -11.7000000765532],
  },
  {
    name: 'Congo',
    continent: 'Africa',
    isoA2: 'CG',
    capital: 'Brazzaville',
    capitalCoordinates: [15.2851414232908, -4.28518799696236],
  },
  {
    name: 'Costa Rica',
    continent: 'North America',
    isoA2: 'CR',
    capital: 'San Jose',
    capitalCoordinates: [-84.0786205965297, 9.93047408038137],
  },
  {
    name: 'Côte d’Ivoire',
    continent: 'Africa',
    isoA2: 'CI',
    capital: 'Yamoussoukro',
    capitalCoordinates: [-5.28299962791556, 6.81800396969163],
  },
  {
    name: 'Croatia',
    continent: 'Europe',
    isoA2: 'HR',
    capital: 'Zagreb',
    capitalCoordinates: [15.9640023900851, 45.8070030434815],
  },
  {
    name: 'Cuba',
    continent: 'North America',
    isoA2: 'CU',
    capital: 'Havana',
    capitalCoordinates: [-82.416455562159, 23.0489550066226],
  },
  {
    name: 'Cyprus',
    continent: 'Asia',
    isoA2: 'CY',
    capital: 'Nicosia',
    capitalCoordinates: [33.3690033925856, 35.1710010679089],
  },
  {
    name: 'Czech Republic',
    continent: 'Europe',
    isoA2: 'CZ',
    capital: 'Prague',
    capitalCoordinates: [14.4569973166976, 50.1059969469927],
  },
  {
    name: 'Democratic Republic of the Congo',
    continent: 'Africa',
    isoA2: 'CD',
    capital: 'Kinshasa',
    capitalCoordinates: [15.2990013416713, -4.32099899174869],
  },
  {
    name: 'Denmark',
    continent: 'Europe',
    isoA2: 'DK',
    capital: 'Copenhagen',
    capitalCoordinates: [12.5499963955359, 55.7199989694362],
  },
  {
    name: 'Djibouti',
    continent: 'Africa',
    isoA2: 'DJ',
    capital: 'Djibouti',
    capitalCoordinates: [43.1000013832157, 11.5000020243489],
  },
  {
    name: 'Dominica',
    continent: 'North America',
    isoA2: 'DM',
    capital: 'Roseau',
    capitalCoordinates: [-61.3884686846599, 15.2990009526589],
  },
  {
    name: 'Dominican Republic',
    continent: 'North America',
    isoA2: 'DO',
    capital: 'Santo Domingo',
    capitalCoordinates: [-69.8990036733499, 18.4889970134254],
  },
  {
    name: 'Ecuador',
    continent: 'South America',
    isoA2: 'EC',
    capital: 'Quito',
    capitalCoordinates: [-78.5242795702664, -0.229499918330703],
  },
  {
    name: 'Egypt',
    continent: 'Africa',
    isoA2: 'EG',
    capital: 'Cairo',
    capitalCoordinates: [31.250799318015, 30.0779099967854],
  },
  {
    name: 'El Salvador',
    continent: 'North America',
    isoA2: 'SV',
    capital: 'San Salvador',
    capitalCoordinates: [-89.2002326108074, 13.7014109517239],
  },
  {
    name: 'Equatorial Guinea',
    continent: 'Africa',
    isoA2: 'GQ',
    capital: 'Malabo',
    capitalCoordinates: [8.77256131186965, 3.74360403670163],
  },
  {
    name: 'Eritrea',
    continent: 'Africa',
    isoA2: 'ER',
    capital: 'Asmara',
    capitalCoordinates: [38.9700003852312, 15.3299970349014],
  },
  {
    name: 'Estonia',
    continent: 'Europe',
    isoA2: 'EE',
    capital: 'Tallinn',
    capitalCoordinates: [24.7500003192491, 59.4166679329812],
  },
  {
    name: 'Eswatini',
    continent: 'Africa',
    isoA2: 'SZ',
    capital: 'Mbabane',
    capitalCoordinates: [31.1913003303371, -26.3033819273915],
  },
  {
    name: 'Ethiopia',
    continent: 'Africa',
    isoA2: 'ET',
    capital: 'Addis Ababa',
    capitalCoordinates: [38.70000039131, 9.02999706641611],
  },
  {
    name: 'Fiji',
    continent: 'Oceania',
    isoA2: 'FJ',
    capital: 'Suva',
    capitalCoordinates: [178.447725350495, -18.1345319714697],
  },
  {
    name: 'Finland',
    continent: 'Europe',
    isoA2: 'FI',
    capital: 'Helsinki',
    capitalCoordinates: [24.9767013482954, 60.1964189912231],
  },
  {
    name: 'France',
    continent: 'Europe',
    isoA2: 'FR',
    capital: 'Paris',
    capitalCoordinates: [2.3549531482218, 48.8582874334995],
  },
  {
    name: 'Gabon',
    continent: 'Africa',
    isoA2: 'GA',
    capital: 'Libreville',
    capitalCoordinates: [9.45399637698068, 0.390995954817697],
  },
  {
    name: 'Gambia',
    continent: 'Africa',
    isoA2: 'GM',
    capital: 'Banjul',
    capitalCoordinates: [-16.596791560041, 13.463954974192],
  },
  {
    name: 'Georgia',
    continent: 'Asia',
    isoA2: 'GE',
    capital: 'T’Bilisi',
    capitalCoordinates: [44.7831274052602, 41.7218130345648],
  },
  {
    name: 'Germany',
    continent: 'Europe',
    isoA2: 'DE',
    capital: 'Berlin',
    capitalCoordinates: [13.3275693578572, 52.5162689233538],
  },
  {
    name: 'Ghana',
    continent: 'Africa',
    isoA2: 'GH',
    capital: 'Accra',
    capitalCoordinates: [-0.200924638491358, 5.55856195379618],
  },
  {
    name: 'Greece',
    continent: 'Europe',
    isoA2: 'GR',
    capital: 'Athens',
    capitalCoordinates: [23.6529993798512, 37.9439999862214],
  },
  {
    name: 'Grenada',
    continent: 'North America',
    isoA2: 'GD',
    capital: 'Saint George’s',
    capitalCoordinates: [-61.7450035590569, 12.0650039453358],
  },
  {
    name: 'Guatemala',
    continent: 'North America',
    isoA2: 'GT',
    capital: 'Guatemala',
    capitalCoordinates: [-90.5248976941474, 14.6180070669831],
  },
  {
    name: 'Guinea',
    continent: 'Africa',
    isoA2: 'GN',
    capital: 'Conakry',
    capitalCoordinates: [-13.6719986183709, 9.54999901599671],
  },
  {
    name: 'Guinea-Bissau',
    continent: 'Africa',
    isoA2: 'GW',
    capital: 'Bissau',
    capitalCoordinates: [-15.5979987184284, 11.8639980604815],
  },
  {
    name: 'Guyana',
    continent: 'South America',
    isoA2: 'GY',
    capital: 'Georgetown',
    capitalCoordinates: [-58.1699966922946, 6.76999798761869],
  },
  {
    name: 'Haiti',
    continent: 'North America',
    isoA2: 'HT',
    capital: 'Port-au-Prince',
    capitalCoordinates: [-72.3431066325168, 18.5266170755727],
  },
  {
    name: 'Honduras',
    continent: 'North America',
    isoA2: 'HN',
    capital: 'Tegucigalpa',
    capitalCoordinates: [-87.2029975874556, 14.0990039767684],
  },
  {
    name: 'Hungary',
    continent: 'Europe',
    isoA2: 'HU',
    capital: 'Budapest',
    capitalCoordinates: [19.0940043360661, 47.5149959640048],
  },
  {
    name: 'Iceland',
    continent: 'Europe',
    isoA2: 'IS',
    capital: 'Reykjavik',
    capitalCoordinates: [-21.8950016123648, 64.1349989178855],
  },
  {
    name: 'India',
    continent: 'Asia',
    isoA2: 'IN',
    capital: 'Chandigarh',
    capitalCoordinates: [76.784004416275, 30.7379970079439],
  },
  {
    name: 'Indonesia',
    continent: 'Asia',
    isoA2: 'ID',
    capital: 'Jakarta',
    capitalCoordinates: [106.800003399727, -6.16666504951912],
  },
  {
    name: 'Iran',
    continent: 'Asia',
    isoA2: 'IR',
    capital: 'Tehran',
    capitalCoordinates: [51.4479963361798, 35.7740010157203],
  },
  {
    name: 'Iraq',
    continent: 'Asia',
    isoA2: 'IQ',
    capital: 'Baghdad',
    capitalCoordinates: [44.3979994368338, 33.3340020512978],
  },
  {
    name: 'Ireland',
    continent: 'Europe',
    isoA2: 'IE',
    capital: 'Dublin',
    capitalCoordinates: [-6.2573487127658, 53.3415599261814],
  },
  {
    name: 'Israel',
    continent: 'Asia',
    isoA2: 'IL',
    capital: 'Jerusalem',
    capitalCoordinates: [35.2252173787838, 31.7737440054595],
  },
  {
    name: 'Italy',
    continent: 'Europe',
    isoA2: 'IT',
    capital: 'Rome',
    capitalCoordinates: [12.519999338143, 41.8799970439333],
  },
  {
    name: 'Jamaica',
    continent: 'North America',
    isoA2: 'JM',
    capital: 'Kingston',
    capitalCoordinates: [-76.7995196799243, 17.9669250287537],
  },
  {
    name: 'Japan',
    continent: 'Asia',
    isoA2: 'JP',
    capital: 'Tokyo',
    capitalCoordinates: [139.809006365241, 35.683002048058],
  },
  {
    name: 'Jordan',
    continent: 'Asia',
    isoA2: 'JO',
    capital: 'Amman',
    capitalCoordinates: [35.9329054335016, 31.9493789286098],
  },
  {
    name: 'Kazakhstan',
    continent: 'Asia',
    isoA2: 'KZ',
    capital: 'Astana',
    capitalCoordinates: [71.4320014183212, 51.1890029333446],
  },
  {
    name: 'Kenya',
    continent: 'Africa',
    isoA2: 'KE',
    capital: 'Nairobi',
    capitalCoordinates: [36.8039973486453, -1.26999894459972],
  },
  {
    name: 'Kiribati',
    continent: 'Oceania',
    isoA2: 'KI',
    capital: 'Tarawa',
    capitalCoordinates: [172.921113428078, 1.34075698115504],
  },
  {
    name: 'Kuwait',
    continent: 'Asia',
    isoA2: 'KW',
    capital: 'Kuwait',
    capitalCoordinates: [47.9740414038836, 29.3859180671288],
  },
  {
    name: 'Kyrgyzstan',
    continent: 'Asia',
    isoA2: 'KG',
    capital: 'Bishkek',
    capitalCoordinates: [74.7700024231043, 42.8799959304531],
  },
  {
    name: 'Laos',
    continent: 'Asia',
    isoA2: 'LA',
    capital: 'Vientiane',
    capitalCoordinates: [102.680235414767, 18.0017369986903],
  },
  {
    name: 'Latvia',
    continent: 'Europe',
    isoA2: 'LV',
    capital: 'Riga',
    capitalCoordinates: [24.0499983185597, 56.8800000342864],
  },
  {
    name: 'Lebanon',
    continent: 'Asia',
    isoA2: 'LB',
    capital: 'Beirut',
    capitalCoordinates: [35.4999963752949, 33.8833260504261],
  },
  {
    name: 'Lesotho',
    continent: 'Africa',
    isoA2: 'LS',
    capital: 'Maseru',
    capitalCoordinates: [27.4920033208027, -29.3079960774895],
  },
  {
    name: 'Liberia',
    continent: 'Africa',
    isoA2: 'LR',
    capital: 'Monrovia',
    capitalCoordinates: [-10.7970026884155, 6.3009989291765],
  },
  {
    name: 'Libya',
    continent: 'Africa',
    isoA2: 'LY',
    capital: 'Tripoli',
    capitalCoordinates: [13.1568933180342, 32.8931279336136],
  },
  {
    name: 'Liechtenstein',
    continent: 'Europe',
    isoA2: 'LI',
    capital: 'Vaduz',
    capitalCoordinates: [9.52100137246572, 47.1429989584405],
  },
  {
    name: 'Lithuania',
    continent: 'Europe',
    isoA2: 'LT',
    capital: 'Vilnius',
    capitalCoordinates: [25.2759603424903, 54.6885629867223],
  },
  {
    name: 'Luxembourg',
    continent: 'Europe',
    isoA2: 'LU',
    capital: 'Luxembourg',
    capitalCoordinates: [6.12000040771403, 49.6080000214909],
  },
  {
    name: 'Madagascar',
    continent: 'Africa',
    isoA2: 'MG',
    capital: 'Antananarivo',
    capitalCoordinates: [47.5280013828146, -18.9080009390465],
  },
  {
    name: 'Malawi',
    continent: 'Africa',
    isoA2: 'MW',
    capital: 'Lilongwe',
    capitalCoordinates: [33.7740033007257, -13.9830030387956],
  },
  {
    name: 'Malaysia',
    continent: 'Asia',
    isoA2: 'MY',
    capital: 'Kuala Lumpur',
    capitalCoordinates: [101.708001376563, 3.14999992008404],
  },
  {
    name: 'Maldives',
    continent: 'Asia',
    isoA2: 'MV',
    capital: 'Malé',
    capitalCoordinates: [73.508889, 4.175278],
  },
  {
    name: 'Mali',
    continent: 'Africa',
    isoA2: 'ML',
    capital: 'Bamako',
    capitalCoordinates: [-7.98648266718402, 12.6529559675785],
  },
  {
    name: 'Malta',
    continent: 'Europe',
    isoA2: 'MT',
    capital: 'Valletta',
    capitalCoordinates: [14.5040044394045, 35.912997029338],
  },
  {
    name: 'Marshall Islands',
    continent: 'Oceania',
    isoA2: 'MH',
    capital: 'Majuro',
    capitalCoordinates: [171.367659408365, 7.12098005783611],
  },
  {
    name: 'Mauritania',
    continent: 'Africa',
    isoA2: 'MR',
    capital: 'Nouakchott',
    capitalCoordinates: [-15.9779966934242, 18.0839969398018],
  },
  {
    name: 'Mauritius',
    continent: 'Africa',
    isoA2: 'MU',
    capital: 'Port Louis',
    capitalCoordinates: [57.4959962993063, -20.1650040567749],
  },
  {
    name: 'Mexico',
    continent: 'North America',
    isoA2: 'MX',
    capital: 'Mexico City',
    capitalCoordinates: [-99.1275746461327, 19.4270490779828],
  },
  {
    name: 'Micronesia',
    continent: 'Oceania',
    isoA2: 'FM',
    capital: 'Palikir',
    capitalCoordinates: [158.216706285642, 6.96670195927221],
  },
  {
    name: 'Moldova',
    continent: 'Europe',
    isoA2: 'MD',
    capital: 'Chisinau',
    capitalCoordinates: [28.8299972854611, 46.9999980747902],
  },
  {
    name: 'Monaco',
    continent: 'Europe',
    isoA2: 'MC',
    capital: 'Monaco',
    capitalCoordinates: [7.42400138106433, 43.7450040043555],
  },
  {
    name: 'Mongolia',
    continent: 'Asia',
    isoA2: 'MN',
    capital: 'Ulaanbaatar',
    capitalCoordinates: [106.911999430501, 47.9289960319097],
  },
  {
    name: 'Montenegro',
    continent: 'Europe',
    isoA2: 'ME',
    capital: 'Podgorica',
    capitalCoordinates: [19.4000043071123, 42.4999979554574],
  },
  {
    name: 'Morocco',
    continent: 'Africa',
    isoA2: 'MA',
    capital: 'Rabat',
    capitalCoordinates: [-6.8329976868925, 34.0149959369738],
  },
  {
    name: 'Mozambique',
    continent: 'Africa',
    isoA2: 'MZ',
    capital: 'Maputo',
    capitalCoordinates: [32.5739973887175, -25.9620030393926],
  },
  {
    name: 'Myanmar',
    continent: 'Asia',
    isoA2: 'MM',
    capital: 'Nay Pyi Taw',
    capitalCoordinates: [96.2090421169743, 19.7334891618559],
  },
  {
    name: 'Namibia',
    continent: 'Africa',
    isoA2: 'NA',
    capital: 'Windhoek',
    capitalCoordinates: [17.0769963322286, -22.5600030497911],
  },
  {
    name: 'Nauru',
    continent: 'Oceania',
    isoA2: 'NR',
    capital: 'Yaren',
    capitalCoordinates: [166.916700371393, -0.516698959904662],
  },
  {
    name: 'Nepal',
    continent: 'Asia',
    isoA2: 'NP',
    capital: 'Kathmandu',
    capitalCoordinates: [85.3129534336424, 27.7120169316581],
  },
  {
    name: 'Netherlands',
    continent: 'Europe',
    isoA2: 'NL',
    capital: 'Amsterdam',
    capitalCoordinates: [4.89483932469335, 52.3730429819271],
  },
  {
    name: 'New Zealand',
    continent: 'Oceania',
    isoA2: 'NZ',
    capital: 'Wellington',
    capitalCoordinates: [174.807216410839, -41.3348400516574],
  },
  {
    name: 'Nicaragua',
    continent: 'North America',
    isoA2: 'NI',
    capital: 'Managua',
    capitalCoordinates: [-86.2730006054865, 12.1509990181155],
  },
  {
    name: 'Niger',
    continent: 'Africa',
    isoA2: 'NE',
    capital: 'Niamey',
    capitalCoordinates: [2.12000436518366, 13.5140040175197],
  },
  {
    name: 'Nigeria',
    continent: 'Africa',
    isoA2: 'NG',
    capital: 'Abuja',
    capitalCoordinates: [7.25638529958087, 9.05726695310761],
  },
  {
    name: 'North Korea',
    continent: 'Asia',
    isoA2: 'KP',
    capital: 'P’yongyang',
    capitalCoordinates: [125.75700034542, 39.0290040222725],
  },
  {
    name: 'North Macedonia',
    continent: 'Europe',
    isoA2: 'MK',
    capital: 'Skopje',
    capitalCoordinates: [21.433338432301, 41.9833349696655],
  },
  {
    name: 'Norway',
    continent: 'Europe',
    isoA2: 'NO',
    capital: 'Oslo',
    capitalCoordinates: [10.7119983540751, 59.9380020260173],
  },
  {
    name: 'Oman',
    continent: 'Asia',
    isoA2: 'OM',
    capital: 'Muscat',
    capitalCoordinates: [58.5880024454231, 23.6069999945829],
  },
  {
    name: 'Pakistan',
    continent: 'Asia',
    isoA2: 'PK',
    capital: 'Islamabad',
    capitalCoordinates: [73.06054232446, 33.7181579687109],
  },
  {
    name: 'Palau',
    continent: 'Oceania',
    isoA2: 'PW',
    capital: 'Koror',
    capitalCoordinates: [134.491680302558, 7.34061592754295],
  },
  {
    name: 'Panama',
    continent: 'North America',
    isoA2: 'PA',
    capital: 'Panama',
    capitalCoordinates: [-79.5170785937481, 9.00287992114157],
  },
  {
    name: 'Papua New Guinea',
    continent: 'Oceania',
    isoA2: 'PG',
    capital: 'Port Moresby',
    capitalCoordinates: [147.147948324248, -9.49718702033119],
  },
  {
    name: 'Paraguay',
    continent: 'South America',
    isoA2: 'PY',
    capital: 'Asuncion',
    capitalCoordinates: [-57.6219955695368, -25.3050029604101],
  },
  {
    name: 'Peru',
    continent: 'South America',
    isoA2: 'PE',
    capital: 'Lima',
    capitalCoordinates: [-77.0450036007241, -12.0819959357647],
  },
  {
    name: 'Philippines',
    continent: 'Asia',
    isoA2: 'PH',
    capital: 'Manila',
    capitalCoordinates: [120.966948411715, 14.6167020628478],
  },
  {
    name: 'Poland',
    continent: 'Europe',
    isoA2: 'PL',
    capital: 'Warsaw',
    capitalCoordinates: [21.0118773681439, 52.2449460530621],
  },
  {
    name: 'Portugal',
    continent: 'Europe',
    isoA2: 'PT',
    capital: 'Lisbon',
    capitalCoordinates: [-9.129995602181, 38.7299970596906],
  },
  {
    name: 'Qatar',
    continent: 'Asia',
    isoA2: 'QA',
    capital: 'Doha',
    capitalCoordinates: [51.5323354139835, 25.2843569253056],
  },
  {
    name: 'Romania',
    continent: 'Europe',
    isoA2: 'RO',
    capital: 'Bucharest',
    capitalCoordinates: [26.1229684278301, 44.4304800149368],
  },
  {
    name: 'Russia',
    continent: 'Europe',
    isoA2: 'RU',
    capital: 'Moscow',
    capitalCoordinates: [37.7000013393066, 55.749996026829],
  },
  {
    name: 'Rwanda',
    continent: 'Africa',
    isoA2: 'RW',
    capital: 'Kigali',
    capitalCoordinates: [30.059001395496, -1.95000307251088],
  },
  {
    name: 'Saint Kitts and Nevis',
    continent: 'North America',
    isoA2: 'KN',
    capital: 'Basseterre',
    capitalCoordinates: [-62.7319975812628, 17.29299597145],
  },
  {
    name: 'Saint Lucia',
    continent: 'North America',
    isoA2: 'LC',
    capital: 'Castries',
    capitalCoordinates: [-60.9830006232485, 14.0000040396746],
  },
  {
    name: 'Saint Vincent and the Grenadines',
    continent: 'North America',
    isoA2: 'VC',
    capital: 'Kingstown',
    capitalCoordinates: [-61.2293126242782, 13.155363032594],
  },
  {
    name: 'Samoa',
    continent: 'Oceania',
    isoA2: 'WS',
    capital: 'Apia',
    capitalCoordinates: [-171.739493590236, -13.8370229528312],
  },
  {
    name: 'San Marino',
    continent: 'Europe',
    isoA2: 'SM',
    capital: 'San Marino',
    capitalCoordinates: [12.466665444183, 43.9166610313093],
  },
  {
    name: 'Sao Tome and Principe',
    continent: 'Africa',
    isoA2: 'ST',
    capital: 'Sao Tome',
    capitalCoordinates: [6.72800441589141, 0.336995989130222],
  },
  {
    name: 'Saudi Arabia',
    continent: 'Asia',
    isoA2: 'SA',
    capital: 'Riyadh',
    capitalCoordinates: [46.770003317039, 24.6500009682933],
  },
  {
    name: 'Senegal',
    continent: 'Africa',
    isoA2: 'SN',
    capital: 'Dakar',
    capitalCoordinates: [-17.4519986987523, 14.6870010105662],
  },
  {
    name: 'Serbia',
    continent: 'Europe',
    isoA2: 'RS',
    capital: 'Belgrade',
    capitalCoordinates: [20.4125584388445, 44.7996780298918],
  },
  {
    name: 'Seychelles',
    continent: 'Africa',
    isoA2: 'SC',
    capital: 'Victoria',
    capitalCoordinates: [55.4450044057623, -4.61699994366411],
  },
  {
    name: 'Sierra Leone',
    continent: 'Africa',
    isoA2: 'SL',
    capital: 'Freetown',
    capitalCoordinates: [-13.2389997025373, 8.48600097917455],
  },
  {
    name: 'Singapore',
    continent: 'Asia',
    isoA2: 'SG',
    capital: 'Singapore',
    capitalCoordinates: [103.831794330751, 1.268855986133],
  },
  {
    name: 'Slovakia',
    continent: 'Europe',
    isoA2: 'SK',
    capital: 'Bratislava',
    capitalCoordinates: [17.1299974385502, 48.149999955026],
  },
  {
    name: 'Slovenia',
    continent: 'Europe',
    isoA2: 'SI',
    capital: 'Ljubljana',
    capitalCoordinates: [14.6396073760768, 46.0682999208059],
  },
  {
    name: 'Solomon Islands',
    continent: 'Oceania',
    isoA2: 'SB',
    capital: 'Honiara',
    capitalCoordinates: [159.951780441486, -9.43384500563911],
  },
  {
    name: 'Somalia',
    continent: 'Africa',
    isoA2: 'SO',
    capital: 'Mogadishu',
    capitalCoordinates: [45.3441423284496, 2.04117302195931],
  },
  {
    name: 'South Africa',
    continent: 'Africa',
    isoA2: 'ZA',
    capital: 'Pretoria',
    capitalCoordinates: [28.2179973433686, -25.7309999316617],
  },
  {
    name: 'South Korea',
    continent: 'Asia',
    isoA2: 'KR',
    capital: 'Pusan',
    capitalCoordinates: [129.054987401444, 35.1579960381113],
  },
  {
    name: 'South Sudan',
    continent: 'Africa',
    isoA2: 'SS',
    capital: 'Juba',
    capitalCoordinates: [31.5971185551713, 4.84406077135149],
  },
  {
    name: 'Spain',
    continent: 'Europe',
    isoA2: 'ES',
    capital: 'Madrid',
    capitalCoordinates: [-3.69097169824494, 40.4422200735065],
  },
  {
    name: 'Sri Lanka',
    continent: 'Asia',
    isoA2: 'LK',
    capital: 'Colombo',
    capitalCoordinates: [79.8480003916203, 6.92700292591639],
  },
  {
    name: 'Sudan',
    continent: 'Africa',
    isoA2: 'SD',
    capital: 'Khartoum',
    capitalCoordinates: [32.529996442161, 15.550001933168],
  },
  {
    name: 'Suriname',
    continent: 'South America',
    isoA2: 'SR',
    capital: 'Paramaribo',
    capitalCoordinates: [-55.1699997017677, 5.82599695100208],
  },
  {
    name: 'Sweden',
    continent: 'Europe',
    isoA2: 'SE',
    capital: 'Stockholm',
    capitalCoordinates: [17.9914504270048, 59.3311679873094],
  },
  {
    name: 'Switzerland',
    continent: 'Europe',
    isoA2: 'CH',
    capital: 'Bern',
    capitalCoordinates: [7.4459973035419, 46.9479959933184],
  },
  {
    name: 'Syria',
    continent: 'Asia',
    isoA2: 'SY',
    capital: 'Damascus',
    capitalCoordinates: [36.2999973379277, 33.4999980477593],
  },
  {
    name: 'Taiwan',
    continent: 'Asia',
    isoA2: 'TW',
    capital: 'Taipei',
    capitalCoordinates: [121.5625, 25.0375],
  },
  {
    name: 'Tajikistan',
    continent: 'Asia',
    isoA2: 'TJ',
    capital: 'Dushanbe',
    capitalCoordinates: [68.9000042959033, 38.6299979322633],
  },
  {
    name: 'Tanzania',
    continent: 'Africa',
    isoA2: 'TZ',
    capital: 'Dar es Salaam',
    capitalCoordinates: [39.2533472981898, -6.8173560640002],
  },
  {
    name: 'Thailand',
    continent: 'Asia',
    isoA2: 'TH',
    capital: 'Bangkok',
    capitalCoordinates: [100.516671441832, 13.7500019185316],
  },
  {
    name: 'Timor-Leste',
    continent: 'Asia',
    isoA2: 'TL',
    capital: 'Dili',
    capitalCoordinates: [125.58099639371, -8.57099698993847],
  },
  {
    name: 'Togo',
    continent: 'Africa',
    isoA2: 'TG',
    capital: 'Lome',
    capitalCoordinates: [1.20154540037453, 6.10283704648669],
  },
  {
    name: 'Tonga',
    continent: 'Oceania',
    isoA2: 'TO',
    capital: 'Nuku’alofa',
    capitalCoordinates: [-175.245650649682, -21.1309020566411],
  },
  {
    name: 'Trinidad and Tobago',
    continent: 'North America',
    isoA2: 'TT',
    capital: 'Port of Spain',
    capitalCoordinates: [-61.4900605923055, 10.6397370430824],
  },
  {
    name: 'Tunisia',
    continent: 'Africa',
    isoA2: 'TN',
    capital: 'Tunis',
    capitalCoordinates: [10.166004382618, 36.8190000391301],
  },
  {
    name: 'Turkey',
    continent: 'Asia',
    isoA2: 'TR',
    capital: 'Ankara',
    capitalCoordinates: [32.8529973769201, 39.929003946849],
  },
  {
    name: 'Turkmenistan',
    continent: 'Asia',
    isoA2: 'TM',
    capital: 'Ashgabat',
    capitalCoordinates: [58.3901374404177, 37.9504169460685],
  },
  {
    name: 'Tuvalu',
    continent: 'Oceania',
    isoA2: 'TV',
    capital: 'Funafuti',
    capitalCoordinates: [179.221887363636, -8.53649993540501],
  },
  {
    name: 'Uganda',
    continent: 'Africa',
    isoA2: 'UG',
    capital: 'Kampala',
    capitalCoordinates: [32.5749964135671, 0.323001036084183],
  },
  {
    name: 'Ukraine',
    continent: 'Europe',
    isoA2: 'UA',
    capital: 'Kyiv',
    capitalCoordinates: [30.5021073912898, 50.4481590691498],
  },
  {
    name: 'United Arab Emirates',
    continent: 'Asia',
    isoA2: 'AE',
    capital: 'Abu Dhabi',
    capitalCoordinates: [54.3709984136918, 24.4760040024004],
  },
  {
    name: 'United Kingdom',
    continent: 'Europe',
    isoA2: 'GB',
    capital: 'London',
    capitalCoordinates: [-0.178001676555652, 51.4879109366984],
  },
  {
    name: 'United States of America',
    continent: 'North America',
    isoA2: 'US',
    capital: 'Washington D.C.',
    capitalCoordinates: [-76.9538336884421, 38.8909080742766],
  },
  {
    name: 'Uruguay',
    continent: 'South America',
    isoA2: 'UY',
    capital: 'Montevideo',
    capitalCoordinates: [-56.1699985882875, -34.9200000502336],
  },
  {
    name: 'Uzbekistan',
    continent: 'Asia',
    isoA2: 'UZ',
    capital: 'Tashkent',
    capitalCoordinates: [69.3498693062675, 41.2479360143048],
  },
  {
    name: 'Vanuatu',
    continent: 'Oceania',
    isoA2: 'VU',
    capital: 'Port Vila',
    capitalCoordinates: [168.320997349854, -17.7399990702484],
  },
  {
    name: 'Vatican City',
    continent: 'Europe',
    isoA2: 'VA',
    capital: 'Vatican City',
    capitalCoordinates: [12.4525, 41.9025],
  },
  {
    name: 'Venezuela',
    continent: 'South America',
    isoA2: 'VE',
    capital: 'Caracas',
    capitalCoordinates: [-66.8982775618213, 10.4960429483843],
  },
  {
    name: 'Vietnam',
    continent: 'Asia',
    isoA2: 'VN',
    capital: 'Hanoi',
    capitalCoordinates: [105.820002385985, 21.0300030662423],
  },
  {
    name: 'Yemen',
    continent: 'Asia',
    isoA2: 'YE',
    capital: 'Sanaa',
    capitalCoordinates: [44.2095032891857, 15.3614430672131],
  },
  {
    name: 'Zambia',
    continent: 'Africa',
    isoA2: 'ZM',
    capital: 'Lusaka',
    capitalCoordinates: [28.1700002974131, -15.4299959596787],
  },
  {
    name: 'Zimbabwe',
    continent: 'Africa',
    isoA2: 'ZW',
    capital: 'Harare',
    capitalCoordinates: [31.0200033958254, -17.8299990130609],
  },
];
